import React from "react";
import { JobStatus } from "../../graphql/generated/graphql";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { jobStatusTypes } from "../../options";

interface JobItemProps {
  job: {
    id: number;
    status?: JobStatus;
    translations?: {
      nodes?:
        | {
            title?: string | null;
          }[]
        | null;
    } | null;
  };
  hireStageCandidates: string[];
}

const JobItem: React.FC<JobItemProps> = ({ job, hireStageCandidates }) => {
  const title = job.translations?.nodes?.[0]?.title || "بدون عنوان";
  const truncatedTitle = title.length > 16 ? title.slice(0, 16) + ".." : title;

  return (
    <div className="">
      <Link
        className={`w-full border-2 border-gray-400 rounded-lg p-1 h-11 text-gray2 flex items-center justify-around ${
          hireStageCandidates.length > 0
            ? "bg-green-50 border-green-600"
            : "bg-white"
        }`}
        to={`/candidates?jobId=${job.id}`}
      >
        <span className="w-[40%] p-1 text-sm">{truncatedTitle}</span>
        {hireStageCandidates.length === 0 && (
          <span
            className={`w-[25%] py-1 text-xs text-gray-500 text-center bg-opacity-90 shadow rounded-lg ${
              job.status === JobStatus.Published
                ? "bg-green-200 border border-green-500 text-black"
                : "bg-transparent"
            } rounded`}
          >
            {job.status && jobStatusTypes[job.status]
              ? jobStatusTypes[job.status]
              : "بدون وضعیت"}
          </span>
        )}
        {hireStageCandidates.length > 0 && (
          <p className="w-[32%] py-0.5 text-xs flex text-gray-900 bg-slate-200 border border-slate-500 bg-opacity-70 shadow-md rounded-lg justify-evenly items-center">
            {hireStageCandidates.map((name, index) => (
              <span key={index}>{name}</span>
            ))}
            <CheckCircleIcon width={22} color="green" />
          </p>
        )}
      </Link>
      <div className="h-10 w-[0.1rem] bg-gray-200 m-auto"></div>
    </div>
  );
};

export default JobItem;
